export default __webpack_public_path__ + "static/media/lucio-ult.00910e50.mp3";